module.exports = __webpack_public_path__ + "media/images/smart_ad_server_small_logo-e4375752d120fabcc8fe2522c4b93ea1.png";